import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '& p': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  closeButton: {
    color: theme.palette.green_200.main
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  }
}))
